export default Object.freeze({
  MIPE: 1,
  QUERELLA: 2,
  FINANZAS: 3,
});
